import { useHideNav } from '@/shared/hooks/useHideNav'
import { useStyles } from './styles'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { goToShop } from '@/app/routing/events'
import { useCallback } from 'react'
import { StarterPackItem } from './ui/starterPackItem'
import { TimeDisplay } from '@/shared/ui/timeDisplay'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { AppButton } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'

export const StarterPackPage = () => {
  const { classes } = useStyles()
  useHideNav()
  const handlebb = useCallback(() => {
    goToShop({ tab: 0 })
  }, [])
  useBackButton({ onBack: handlebb })
  return (
    <div className={classes.root}>
      <span className={classes.heading}>GAMED Secret Agent's Kit</span>
      <span className={classes.description}>
        A small case that was left in an underwater laboratory. Made of matte polycarbonate
      </span>
      <div className={classes.imageWrapper}>
        <div className={classes.discountContainer}>
          <span className={classes.discountText}>-35%</span>
        </div>
        <img
          src="https://storage.yandexcloud.net/gamed/cases-and-rewards/default.webp"
          alt=""
          className={classes.packImage}
        />
      </div>
      <span className={classes.packContainsText}>The Pack Contains</span>
      <div className={classes.starterPackList}>
        <StarterPackItem />
        <StarterPackItem />
      </div>
      <div className={classes.timeLeftWrapper}>
        <span className={classes.expiresText}>Expires in:</span>
        <div className={classes.timeLeftContainer}>
          <div className={classes.daysWrapper}>
            <span>6 days</span>
          </div>
          <TimeDisplay timeLeft={{ hours: '20', minutes: '53', seconds: '47' }} />
        </div>
      </div>
      <ButtonWrapper style={{ width: '100%', paddingLeft: '8px', paddingRight: '8px' }}>
        <AppButton className={classes.button}>
          <div className={classes.openForWrapper}>
            <span>Open for 499</span> <Icon view="tgStar" width={24} />
          </div>
          <div className={classes.strikethroughContainer}>
            <span>750</span>
            <Icon view="tgStar" width={24} />
          </div>
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
